import { Box, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import { ModalStyleFeedback } from "../../../../common/components/ModalStyle";
import { useForm } from "react-hook-form";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import {
  getPROPFormData,
  savePROForm,
} from "../../../services/cliinicalChartServices/proFormServices/proFormServices";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";

const PROFormModal = (props) => {
  const {
    openPROFormModal,
    setOpenPROFormModal,
    displayInfo,
    setOpenBackdrop,
  } = props;
  const [openPost, setOpenPost] = useState(false);
  const [finalData, setFinalData] = useState(null);
  const [patchData, setPatchData] = useState(null);

  const { register, handleSubmit, reset, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      general: "",
      food: "",
      positive: "",
      negative: "",
    },
  });

  const onSubmitPRO = (data) => {
    let postObj = {
      id: patchData !== null ? patchData?.id : null,
      general: data?.general,
      food: data?.food,
      positive: data?.positive,
      negative: data?.negative,
      admissionId: displayInfo?.AdmissionId,
      patientId: displayInfo?.PatientId,
    };
    setFinalData(postObj);
    setOpenPost(true);
  };

  const savePRO = () => {
    setOpenBackdrop(true);
    setOpenPost(false);
    savePROForm(finalData)
      .then((response) => {
        successAlert(response?.data?.message);
        setOpenPROFormModal(false);
        reset();
        setOpenBackdrop(false);
        setPatchData(null);
        setFinalData(null);
      })
      .catch((error) => {
        errorAlert(error?.data?.result?.message || error?.message);
        setOpenPost(false);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    if (openPROFormModal === true) {
      setOpenBackdrop(true);
      getPROPFormData(displayInfo?.PatientId)
        .then((response) => {
          setOpenBackdrop(false);
          setPatchData(response?.data?.result);
          setValue("general", response?.data?.result?.general);
          setValue("food", response?.data?.result?.food);
          setValue("positive", response?.data?.result?.positive);
          setValue("negative", response?.data?.result?.negative);
        })
        .catch(() => {
          setPatchData(null);
          setOpenBackdrop(false);
        });
    }
  }, [displayInfo]);

  console.log("patientInfo321", displayInfo);

  console.log("getPROPFormData", patchData);

  return (
    <>
      <Modal open={openPROFormModal}>
        <Box
          sx={ModalStyleFeedback}
          className="space-y-2 w-[90%] lg:w-[80%] max-h-[90%]"
        >
          <div className="flex justify-between">
            <label className="font-semibold">PRO Form</label>
            <button
              type="button"
              onClick={() => {
                setOpenPROFormModal(false);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          <form
            onSubmit={handleSubmit(onSubmitPRO)}
            className="grid lg:grid-cols-2 gap-3"
          >
            <TextField
              name="general"
              {...register("general")}
              //   error={errors.general}
              sx={{ backgroundColor: "white" }}
              label="General"
              placeholder=""
              multiline
              minRows={2}
              fullWidth
            />
            <TextField
              name="food"
              {...register("food")}
              //   error={errors.food}
              sx={{ backgroundColor: "white" }}
              label="Food"
              placeholder=""
              multiline
              minRows={2}
              fullWidth
            />
            <TextField
              name="positive"
              {...register("positive")}
              //   error={errors.positive}
              sx={{ backgroundColor: "white" }}
              label="Positive"
              placeholder=""
              multiline
              minRows={2}
              fullWidth
            />
            <TextField
              name="negative"
              {...register("negative")}
              //   error={errors.negative}
              sx={{ backgroundColor: "white" }}
              label="Negative"
              placeholder=""
              multiline
              minRows={2}
              fullWidth
            />
            <div className="flex justify-end lg:col-span-2">
              <CommonButton
                type="submit"
                label={patchData !== null ? "Update" : "Save"}
                className="bg-customGreen text-white"
              />
            </div>
          </form>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => setOpenPost(false)}
        confirmationSubmitFunc={() => {
          savePRO();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg={`Are you sure want to ${patchData !== null ? "update" : "save"} PRO form ?`}
        confirmationButtonMsg={patchData !== null ? "Update" : "Save"}
      />
    </>
  );
};

export default PROFormModal;
